import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import logoDark from "../../assets/images/80eight/88-footer-white.svg";
import Toaster from "../primitives/toaster";
import bgVideo from "../../assets/images/loader.mp4";

export default function SpinningLoader() {
  return (
    <AnimatePresence>
      <motion.div
        key="spinning-loader-overlay"
        role="status"
        aria-live="polite"
        aria-busy="true"
        className="min-h-screen w-full flex items-center justify-center bg-white dark:bg-black fixed inset-0 z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <span className="sr-only">Loading…</span>
        <div className="relative flex items-center justify-center lg:w-[70%] lg:h-[70%] w-full h-full scale-150 lg:scale-100">
          <video
            src={bgVideo}
            autoPlay
            loop
            muted
            playsInline
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-contain"
          />
          {/* Geometry-proof edge fade: paints page-colored pixels over the
              video perimeter so its hard rectangular edge is never visible. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 dark:hidden"
            style={{
              background:
                "radial-gradient(ellipse at center, rgba(255,255,255,0) 45%, rgb(255,255,255) 78%)",
            }}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 hidden dark:block"
            style={{
              background:
                "radial-gradient(ellipse at center, rgba(0,0,0,0) 45%, rgb(0,0,0) 78%)",
            }}
          />
        </div>
      </motion.div>
      <motion.img
        key="spinning-loader-logo-dark"
        src={logoDark}
        alt=""
        aria-hidden="true"
        className="absolute z-[1000] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-12 w-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      />
      <motion.div
        key="spinning-loader-toaster"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Toaster />
      </motion.div>
    </AnimatePresence>
  );
}
